/*! @pentacode/ui v0.1.0 */
import "./avatar-Cxc8l1TA.js";
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { t as n } from "./decorateMetadata-BXz2gmG4.js";
import { t as r } from "./decorate-C_HUHFGG.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/employee-cell/employee-cell.css.js
var l = t(":host{display:block}.avatar{font-size:.75em}.wrapper{align-items:center;gap:.5em;min-width:0;display:flex}.content{flex:1;align-items:baseline;gap:.3em;min-width:0;display:flex}.name{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.staff-number{opacity:.6;font-size:.85em}"), u = class extends e(i) {
	constructor(...e) {
		super(...e), this.positionColors = [], this.showStaffNumber = !1, this.nameFormat = "firstLast", this.styles = l;
	}
	_formatName() {
		if (!this.employee) return "";
		let { firstName: e, lastName: t } = this.employee;
		return this.nameFormat === "lastFirst" ? `${t}, ${e}` : `${e} ${t}`;
	}
	render() {
		return a`
            <div class="wrapper">
                <ptc-ui-avatar
                    class="avatar"
                    .employee=${this.employee}
                    .positionColors=${this.positionColors}
                ></ptc-ui-avatar>
                <div class="content">
                    <span class="name">${this._formatName()}</span>
                    ${this.showStaffNumber && this.employee?.staffNumber ? a`<span class="staff-number">#${this.employee.staffNumber}</span>` : o}
                </div>
                <slot name="trailing"></slot>
            </div>
        `;
	}
};
r([c({ attribute: !1 }), n("design:type", Object)], u.prototype, "employee", void 0), r([c({ type: Array }), n("design:type", Array)], u.prototype, "positionColors", void 0), r([c({ type: Boolean }), n("design:type", Object)], u.prototype, "showStaffNumber", void 0), r([c({ type: String }), n("design:type", String)], u.prototype, "nameFormat", void 0), u = r([s("ptc-ui-employee-cell")], u);
var d = u;
export { d as n, u as t };

//# sourceMappingURL=employee-cell-COaqnePa.js.map